// extracted by css-extract-rspack-plugin
export default {"profileName":"profileName-uegNYH","moreLink":"moreLink-m7O1X5","contactLink":"contactLink-uXQg70","blurredName":"blurredName-QeVipo"};